import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { withStyles } from '@material-ui/core/styles';
import FormLabel from '@material-ui/core/FormLabel';
import FormControl from '@material-ui/core/FormControl';

import { Field } from 'redux-form';

import Link from 'components/common/Link';

import TemplatesCreateEditFormFieldMenuChoice from './TemplatesCreateEditFormFieldMenuChoice';

const styles = () => ({
  root: {
    marginTop: 16,
  },
  choices: {
    position: 'relative',
  },
  buttonAdd: {
    marginTop: 16,
  },
});

class TemplatesCreateEditFormFieldMenuChoices extends Component {
  constructor(props) {
    super(props);

    this.state = {
      offsetFields: [],
      draggableData: {},
      dragged: false,
      timestamp: Date.parse(new Date()),
    };

    this.onFieldDragStart = this.onFieldDragStart.bind(this);
    this.onFieldDrag = this.onFieldDrag.bind(this);
    this.onFieldDragStop = this.onFieldDragStop.bind(this);
    this.onDraggableDataChange = this.onDraggableDataChange.bind(this);
  }

  onDraggableDataChange(data) {
    this.setState({
      draggableData: {
        ...this.state.draggableData,
        ...data,
      },
    });
  }

  onFieldDragStart() {
    this.setState({ dragged: true });
  }

  onFieldDrag(data) {
    const { fields } = this.props;
    const { draggableData } = this.state;
    let moveDirectionY;
    if (Math.abs(data.defaultY - data.y) > 20) {
      moveDirectionY = data.y > data.defaultY ? 'bottom' : 'top';
    }
    const offsetFields = fields.reduce((accumulator, field, index) => {
      if (index === data.index) {
        return accumulator;
      }
      if (moveDirectionY === 'bottom') {
        if (index > data.index
          && draggableData[index] !== undefined
          && ((draggableData[index].height / 2) - draggableData[index].bounds.top)
          < (data.y + data.height)) {
          return [
            ...accumulator,
            {
              fieldIndex: index,
              offsetY: -data.height,
            },
          ];
        }
        return accumulator;
      }
      if (moveDirectionY === 'top') {
        if (index < data.index
          && draggableData[index] !== undefined
          && ((draggableData[index].height / 2) - draggableData[index].bounds.top)
          > data.y) {
          return [
            ...accumulator,
            {
              fieldIndex: index,
              offsetY: data.height,
            },
          ];
        }
        return accumulator;
      }
      return accumulator;
    }, []);
    this.setState({ offsetFields });
  }

  onFieldDragStop(data) {
    const { fields } = this.props;
    const { offsetFields } = this.state;
    if (offsetFields.length > 0) {
      let moveDirectionY;
      let moveIndex;
      if (Math.abs(data.defaultY - data.y) > 20) {
        moveDirectionY = data.y > data.defaultY ? 'bottom' : 'top';
      }
      this.setState({
        dragged: false,
        offsetFields: [],
      });
      if (moveDirectionY === 'top') {
        moveIndex = offsetFields[0].fieldIndex;
      }
      if (moveDirectionY === 'bottom') {
        moveIndex = offsetFields[offsetFields.length - 1].fieldIndex;
      }
      if (moveIndex !== undefined) {
        fields.move(data.index, moveIndex);
        this.setState({ timestamp: Date.parse(new Date()) });
      }
    }
  }

  render() {
    const {
      fields,
      classes,
    } = this.props;
    const { dragged, offsetFields, timestamp } = this.state;
    return (
      <FormControl
        className={classes.root}
        role="group"
      >
        <FormLabel component="legend">Choices</FormLabel>
        <div className={classes.choices}>
          {fields.map((field, index) => {
            const offsetFieldIndex = offsetFields
              .findIndex(item => (item.fieldIndex === index));
            return (
              <Field
                // eslint-disable-next-line react/no-array-index-key
                key={index}
                index={index}
                name={field}
                component={TemplatesCreateEditFormFieldMenuChoice}
                {...(fields.length > 1)
                  ? {
                    onRemove: () => fields.remove(index),
                    boundsSelector: `.${classes.choices}`,
                    onStartDrag: this.onFieldDragStart,
                    onDrag: this.onFieldDrag,
                    onStopDrag: this.onFieldDragStop,
                    onDraggableDataChange: this.onDraggableDataChange,
                    withTransition: dragged,
                    timestamp,
                    ...offsetFieldIndex !== -1
                      ? {
                        offsetY: offsetFields[offsetFieldIndex].offsetY,
                        offsetX: offsetFields[offsetFieldIndex].offsetX,
                      } : {},
                  }
                  : {
                    dragDisabled: true,
                  }}
              />
            );
          })}
        </div>
        <Link
          className={classes.buttonAdd}
          color="primary"
          bold
          size="sm"
          onClick={() => fields.push('')}
        >
          Add option
        </Link>
      </FormControl>
    );
  }
}

TemplatesCreateEditFormFieldMenuChoices.propTypes = {
  fields: PropTypes.shape({
    name: PropTypes.string,
  }).isRequired,
  classes: PropTypes.shape({
    root: PropTypes.string.isRequired,
    choices: PropTypes.string.isRequired,
    buttonAdd: PropTypes.string.isRequired,
  }).isRequired,
};

TemplatesCreateEditFormFieldMenuChoices.defaultProps = {
  rootRef: null,
  dropActive: false,
};

export default withStyles(styles)(TemplatesCreateEditFormFieldMenuChoices);



// WEBPACK FOOTER //
// ./src/components/settings/TemplatesCreateEditForm/TemplatesCreateEditFormFieldMenuChoices.js